import type { HighlightDetails } from "./Highlight";

// «2 против 4» показываем, только когда врагов рядом заметно больше: на 2 и более.
// Счёт «наших» — союзники рядом и сам игрок.
export const isOutnumbered = (details: HighlightDetails): boolean =>
  details.enemies_near !== null && details.enemies_near > (details.allies_near ?? 0) + 1;
